import { render, staticRenderFns } from "./advantages.vue?vue&type=template&id=1214a255"
import script from "./advantages.vue?vue&type=script&lang=js"
export * from "./advantages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports